module.exports = __webpack_public_path__ + "static/BT-desktop-14-e3f45a3a86f11fb47db982d1823ce0a5.jpg";